import axios from "../utils/axios";

/**
 * Зміна аватарки користувача
 * @param {Object} avatarData  - fileData
 * @returns 
 */
export const setAvatar = async (avatarData) => {
    try {
        const response = await axios.post(`/profile/avatar`, avatarData)
        return response.data.urlAvatar;
    } catch(error) {
        console.log(error);
        return false;
    }
}